import * as React from "react";
import { useMutation } from "@grandvisionhq/graphql";
import { useIntl } from "@grandvisionhq/state";
import { useWishlistId } from "@grandvisionhq/svc-wishlist";
import REMOVE_FROM_SHOPPING_LIST from "../../operations/mutations/operations/mutations/remove-from-shopping-list.js";
const useRemoveFromShoppinglist = ({
  onError,
  onCompleted
}) => {
  const { locale } = useIntl();
  const [hasError, setHasError] = React.useState(false);
  const currentSkus = React.useRef([]);
  const { updateWishlist } = useWishlistId();
  const [mutation, { data, loading, error }] = useMutation(
    REMOVE_FROM_SHOPPING_LIST,
    {
      onError() {
        onError?.(currentSkus.current);
      },
      context: {
        forwardHeaders: {
          "Accept-Language": locale
        }
      }
    }
  );
  const handleOnCompleted = React.useCallback(
    (data2) => {
      if (data2.removeFromShoppinglist.__typename === "RemoveFromShoppinglistFailureResponse") {
        onError?.(currentSkus.current);
      }
      onCompleted?.(data2);
      updateWishlist();
    },
    [onCompleted, onError, updateWishlist, currentSkus]
  );
  const removeFromShoppinglist = React.useCallback(
    async (productSkus, wishlistId) => {
      try {
        currentSkus.current = productSkus;
        if (wishlistId) {
          const { data: data2 } = await mutation({
            variables: {
              input: {
                productSkus,
                shoppinglistId: wishlistId
              }
            }
          });
          if (data2) {
            handleOnCompleted(data2);
            return Promise.resolve(data2);
          }
        }
      } catch (e) {
        setHasError(true);
        console.error("Error while removing a wishlist item from the shopping list", e);
      }
      return Promise.reject();
    },
    [handleOnCompleted, mutation]
  );
  return {
    data: data?.removeFromShoppinglist.__typename === "RemoveFromShoppinglistSuccessResponse" && data.removeFromShoppinglist.result ? data.removeFromShoppinglist.result.items : null,
    removeFromShoppinglist,
    loading,
    error: error ?? hasError ?? data?.removeFromShoppinglist.__typename === "RemoveFromShoppinglistFailureResponse" ?? null
  };
};
export {
  useRemoveFromShoppinglist
};
//# sourceMappingURL=use-remove-from-shopping-list.js.map
